import React from 'react';
import ButtonBlue from "./ButtonBlue";

const BoostModule = () => {
    return (
        <div className="boostModule-content">
            <h1>Boost your links today</h1>
            <ButtonBlue text={"Get Started"} height={55} width={205} borderRadius={40} fontSize={20}/>
        </div>
    );
};

export default BoostModule;
